import LeadEditor from "pages/shared/lead-editor/LeadEditor"
import Loading from "pages/shared/loading/Loading"
import { useContext, useEffect, useState } from "react"
import { useErrorBoundary } from "react-error-boundary"
import { useNavigate, useParams } from "react-router"
import { NotificationContext } from "shared/NotificationContext"
import backofficeApi from 'shared/topchef-api-backoffice';
import { Lead, LeadCreation, NotificationType } from "shared/topchef.types"

const BackofficeValidateLead = () => {

  const navigate = useNavigate();
  
  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;

  const params = useParams();
  const leadId: string = params.leadId || '';

  const [isReady, setReady] = useState<boolean>(false);
  const [currentLead, setCurrentLead] = useState<Lead | null>(null);
  
  const { showBoundary } = useErrorBoundary();

  useEffect(() => {

    async function loadLead() {
      try {
        const lead: Lead = await backofficeApi.loadLeadToValidate(leadId);
        setCurrentLead(lead);
        setReady(true);
      } catch (error: any) { 
        const newError = new Error(`Problème pour récupérer le brief à valider : '${error.message}'`);
        triggerNotification({type: NotificationType.error, message : newError.message}); 
        showBoundary(newError);
      } 
    }

    if (isReady) {
      return;
    }

    loadLead();

  }, [currentLead, isReady, leadId, showBoundary, triggerNotification]);


  const denyLead = async () => {
    try {
      await backofficeApi.refuseLead(leadId);
      triggerNotification({type: NotificationType.information, message : 'Brief refusé 😢'});
      navigate('/backoffice/leads/to-validate');
    } catch (error: any) {
      const newError = new Error(`Erreur lors de la validation du brief : ${error.details}`);
      triggerNotification({type: NotificationType.error, message : `${newError.message}`});
      showBoundary(newError);
    }
  }

  const validateLead = async (leadCreation: LeadCreation) => {
    try {
      await backofficeApi.validateLead(leadId, leadCreation!);
      triggerNotification({type: NotificationType.information, message : 'Brief validé 🎉'});
      navigate('/backoffice/leads/to-validate');
    } catch (error: any) {
      const newError = new Error(`Erreur lors de la validation du brief : ${error.message}`);
      triggerNotification({type: NotificationType.error, message : `${newError.message}`});
      showBoundary(newError);
    }
  };

  const leadToLeadCreation = (lead: Lead): LeadCreation => {
    return {
      type: lead.type,
      targetDate: lead.targetDate.toString(),
      startTime: lead.startTime ?? '',
      endTime: lead.endTime ?? '',
      guests: lead.guests,
      budget: lead.budget,
      region: lead.region,
      city: lead.city,
      description: lead.description,
      contactName: lead.contactName,
      contactCompany: lead.contactCompany,
      contactEmailAddress: lead.contactEmailAddress,
      contactMobilePhone: lead.contactMobilePhone,
      contactLandlinePhone: lead.contactLandlinePhone
    };
  }

  if (!isReady) {
    return (
      <Loading />
    );
  }



  const updateLeadState= (name: string, value: any) => {
    setCurrentLead((prevState) => ({
      ...prevState,
      [name]: value,
    } as Lead));
  }

  return (
      <div className="container p-5 overflow-auto backoffice-lead-to-validate-details" >
      <h4 className="mb-3 text-center">Valider le brief</h4>

      <div className="row mt-4">
        <LeadEditor formData={leadToLeadCreation(currentLead!)} onDataChange={updateLeadState} onSubmit={validateLead} submitButtonLabel="Valider le brief" />
      </div>

      <div className="text-center">
        <button className="btn btn-primary m-3 refuse-btn" onClick={denyLead}>Refuser le brief</button> 
      </div>
    
    </div>
  );

}

export default BackofficeValidateLead;
